import styled from 'styled-components'
import { ReactComponent as ChatBubbleAddIcon } from '@sketch/icons/comment-chat-bubble-plus-17'

export const Wrapper = styled.div`
  width: ${({ theme }) => theme.sidebar.canvasFirstRightWidth}px;
`

export const ChatAddIcon = styled(ChatBubbleAddIcon)`
  width: 17px;
  height: 17px;
`
